/**
 * Created by mobilport on 2018. 09. 17..
 */

// Csak az adószám utolsó 3 karakterét nézzük

export default function(app) {
	app.directive('taxNumberOnlyLast', function () {
		return {
			scope: {
				taxNumberLastChars: '='
			},
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {

				scope.$watch('taxNumberLastChars', function (newValue) {
					if (newValue) {
						const numCheck = /^[0-9]-[0-9]{2}$/.test(newValue);
						ctrl.$setValidity('taxNumberFormat', numCheck);
						ctrl.$setValidity('onlyThree', true);
						if (newValue.length === 2 && newValue.charAt(1) !== '-') {
							scope.taxNumberLastChars = newValue.charAt(0) + '-' + newValue.charAt(1);
						}
					} else {
						ctrl.$setValidity('onlyThree', false);
						ctrl.$setValidity('taxNumberFormat', true);
						ctrl.$touched = true;
					}
				});
			}
		};
	});
};
